import UartChannel from './UartChannel';

export default class ModbusRtuChannel extends UartChannel {
  constructor(...args) {
    super(...args);

    this.rxIndex = 0;
    this.rxBuffer = Buffer.alloc(512);
    this.rxLastTimestamp = Date.now();
  }

  receiveData(data) {
    const now = Date.now();
    const diff = now - this.rxLastTimestamp;
    this.rxLastTimestamp = now;

    // FIXME(daniel): make this timeout better...
    if (diff > 100) {
      this.rxIndex = 0;
    } else if (this.rxIndex >= this.rxBuffer.length) {
      this.rxIndex = -1;
    }

    // console.log(this.name, now, diff, this.rxIndex, data);

    if (this.rxIndex >= 0) {
      this.rxBuffer [this.rxIndex] = data;
      this.rxIndex += 1;

      let expectedLength;
      if (this.rxIndex < 2) {
        // nop
      } else if (this.rxBuffer [1] === 16) {
        if (this.rxIndex < 7) {
          // nop
        } else {
          expectedLength = 7 + this.rxBuffer [6] + 2;
        }
      } else {
        this.rxIndex = -1;
      }

      if (expectedLength == null) {
        // nop
      } else if (this.rxIndex >= expectedLength) {
        const slaveAddress = this.rxBuffer [0];
        const functionCode = this.rxBuffer [1];

        if (functionCode === 16) {
          const startAddress = this.rxBuffer.readUInt16BE(2);
          const registerCount = this.rxBuffer.readUInt16BE(4);
          const values = [];
          for (let index = 0; index < registerCount; index++) {
            values.push(this.rxBuffer.readUInt16BE(7 + index * 2));
          }

          this.emit('writeMultipleRegistersRequest', {
            slaveAddress,
            functionCode,
            startAddress,
            registerCount,
            values,
          });
        } else {
          throw new Error(`Invalid state`);
        }

        this.rxIndex = -1;
      }
    }
  }

}
